import { fetchPhpEigth } from "api";
import { TIPOS_PAGO } from "constants/pago";
import { ambienteAplicacion, urlPago } from "constants/urls";
import { createAction } from "redux-actions";
import PRODUCTOS from "utils/constants/PRODUCTOS";

export const setParametrosPagoAction = createAction("SET_PARAMETROS_PAGO");
export const setLoadingParametrosPagoAction = createAction("SET_LOADING_PARAMETROS_PAGO");
export const setErrorParametrosPagoAction = createAction("SET_ERROR_PARAMETROS_PAGO");

export const resetStateParametrosPagoAction = createAction("RESET_STATE_PARAMETROS_PAGO");

/**
 *
 * @param {string} codProducto
 * @returns {Promise}
 */
export const getParametrosPago =
  (codProducto = PRODUCTOS.APINDIVIDUAL, idCotizacion = "") =>
  (dispatch, getState) => {
    const Data = {
      datosPago: {
        ambiente: ambienteAplicacion,
        cotPasoCodigo: "obtenerParametros",
        prodCodigo: codProducto,
        idCotizacion: idCotizacion,
        numTarjeta: "4656565",
      },
    };
    dispatch(resetStateParametrosPagoAction());
    dispatch(setLoadingParametrosPagoAction(true));

    fetchPhpEigth(urlPago, Data).then((res) => {
      dispatch(setLoadingParametrosPagoAction(false));
      console.log("RES: ", res);
      if (res?.transaccion && res?.pago) {
        switch (codProducto) {
          case PRODUCTOS.TRAVELBTA:
            res.pago.formasPago = res.pago.formasPago?.filter((e) => e.label === "CONTADO");
            break;
          default:
            break;
        }

        const plazosMsi = res.pago.banksplazo_msi?.PlazoEntity?.map((plazo) => {
          const label = plazo.Name;

          return {
            label,
            value: {
              ...plazo,
              label,
              value: plazo.ID,
            },
          };
        });

        res.pago.plazos = plazosMsi;
        const formasPago = res.pago.formasPago;
        res.pago.formasPago = formasPago.map((formaPago) => {
          if (formaPago.tipo === TIPOS_PAGO.MESES_SIN_INTERESES) {
            formaPago.options = plazosMsi;
          }
          return formaPago;
        });

        dispatch(setParametrosPagoAction(res?.pago));
        dispatch(setErrorParametrosPagoAction(null));
      } else {
        dispatch(setParametrosPagoAction(null));
        dispatch(
          setErrorParametrosPagoAction({
            message: "Ha ocurrido un problema al cargar las formas de pago",
          })
        );
      }
    });
  };
